import { Routes, Route, Navigate } from 'react-router-dom';
import SegmentsPage from './index';
import SegmentBuilderPage from './builder/index';
import { useFeature } from '@/hooks/use-feature';

/**
 * SegmentsRoutes handles all segment-related routing.
 * This follows the same pattern as campaigns, where we have a nested Routes
 * component that handles all sub-routes. This makes relative navigation
 * more predictable as '..' will navigate based on route hierarchy
 * rather than URL segments.
 */
export function SegmentsRoutes() {
  const isSegmentsEnabled = useFeature('SEGMENTS');

  if (!isSegmentsEnabled) {
    return <Navigate to="/" replace />;
  }

  return (
    <Routes>
      <Route index element={<SegmentsPage />} />
      <Route path="builder/:segmentId" element={<SegmentBuilderPage />} />
    </Routes>
  );
}
